<template>
  <div class="row user-stats">
    <div class="col s12 m6 l3 indicator-row">
      <stats-indicator icon="mfind-icon-send"
        :stats="getCalculations.started">
        <template slot="header">
          <h6>Rozpoczęte kalkulacje</h6>
        </template>
      </stats-indicator>
    </div>

    <div class="col s12 m6 l3 indicator-row">
      <stats-indicator icon="mfind-icon-list"
        :stats="getCalculations.completed">
        <template slot="header">
          <h6>Zakończone kalkulacje</h6>
        </template>
      </stats-indicator>
    </div>

    <div class="col s12 m6 l3 indicator-row" v-if="showStatsFor('cpl')">
      <stats-indicator icon="mfind-icon-doc"
        :stats="getCalculations.phone_confirmed">
        <template slot="header">
          <h6>Potwierdzone kalkulacje</h6>
        </template>
      </stats-indicator>
    </div>

    <div class="col s12 m6 l3 indicator-row" v-if="showStatsFor('cps')">
      <stats-indicator icon="mfind-icon-doc"
        :stats="getCalculations.sold_policies">
        <template slot="header">
          <h6>Sprzedane polisy</h6>
        </template>
      </stats-indicator>
    </div>

    <div class="col s12 m6 l3 indicator-row">
      <stats-indicator icon="mfind-icon-wallet"
        :stats="getPayment.saldo" unit="zł">
        <template slot="header">
          <h6>Twoje środki</h6>
        </template>
      </stats-indicator>
    </div>

    <Loader :loading="getPending"/>
  </div>
</template>

<script>
import StatsIndicator from '@/components/statsIndicator'
import Loader from '@/components/loader'
import { mapGetters as mapGettersGlobal, createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('statistics')
export default {
  components: { StatsIndicator, Loader },
  created () {
    this.$store.dispatch('statistics/getAll', 'get')
  },
  methods: {
    showStatsFor (settlementType) {
      return this.getUserSettlementType(settlementType)
    }
  },
  computed: {
    // mix the getters into the computed object
    ...mapGetters([
      'getAll',
      'getPending',
      'getPayment',
      'getCalculations'
    ]),
    ...mapGettersGlobal([ 'getUserSettlementType' ])
  }
}
</script>

<style lang="scss">
@import 'src/stylesheets/variables';
@import 'src/stylesheets/mixins';
.user-stats {
  .indicator-row {
    &:after {
      @include indicator-row-after;
    }

    &:before {
      @include indicator-row-before;

      @media #{$small-and-down} {
        content: none;
      }
    }
  }

  .indicator-row:nth-child(-n + 4):after,
  .indicator-row:last-child:before,
  .indicator-row:nth-child(n+4):before {
    content: none;
  }

  .indicator-row:nth-child(5) {
    width: 100%;
  }

  @media #{$medium-and-up} {
    .top-box.indicator-row:after {
      content: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// statsGrid.vue?a0e24812